import React from "react";
import {
  TagView,
  WordView,
  PlatzBlobViewTokensItem,
  SourceLocation,
} from "../api-generated";
import {
  isNumberToken,
  isWordToken,
  isNewLineToken,
  isTabToken,
  isPunctuationToken,
  isSpaceToken,
} from "../utils";
import Word from "./Word";
import clsx from "clsx";

interface TokenProps {
  token: PlatzBlobViewTokensItem;
  location: SourceLocation;
  tags?: TagView[];
  refCallback?: (ref: HTMLElement | null) => void;
  isFocused?: boolean;
  isInMultiSelect?: boolean;
  onClick?: () => void;
  onlyFocusOnHover?: boolean;
  onWordHover?: () => void;
  isHighlightedForDragSelection: boolean;
  isCurrentlyPlaying?: boolean;
}

const Token: React.FC<TokenProps> = ({
  token,
  refCallback,
  location,
  isFocused,
  isInMultiSelect = false,
  onClick,
  onlyFocusOnHover = false,
  onWordHover,
  isHighlightedForDragSelection = false,
  isCurrentlyPlaying = false,
}: TokenProps) => {
  if (isNewLineToken(token)) {
    return null;
    //return <br className="new-line" />;
  }

  if (isTabToken(token)) {
    return <div className="tab inline-block w-8"></div>;
  }

  let innerComponent: React.ReactNode = null;
  //let isSpace = false; // TODO: def don't have this
  if (isWordToken(token)) {
    innerComponent = (
      <Word
        // @ts-ignore
        word={token.word as WordView}
        location={location}
        isFocused={isFocused}
        isInMultiSelect={isInMultiSelect}
        onlyFocusOnHover={onlyFocusOnHover}
        onHover={onWordHover}
      />
    );
  }

  if (isPunctuationToken(token)) {
    // @ts-ignore
    innerComponent = <div className="punctuation">{token.valueAsString}</div>;
  }

  if (isNumberToken(token)) {
    // @ts-ignore
    innerComponent = <div className="number">{token.valueAsString}</div>;
  }

  if (isSpaceToken(token)) {
    //isSpace = true;
    innerComponent = <div className="space w-[3px]" />;
    //<div style={{ whiteSpace: "pre-wrap" }}>{token.text}</div>
  }

  return (
    <div
      className={clsx("token-container inline-block text-sm", {
        "bg-rose-400": isHighlightedForDragSelection,
        "bg-indigo-200": isCurrentlyPlaying,
      })}
      ref={refCallback}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <div className="token flex flex-col justify-start">{innerComponent}</div>
    </div>
  );
};

export default Token;
